import React, { useEffect, useReducer, useRef  } from "react";

// Interface for action table item
interface ActionTableItem {
	type?: string;
	child?: boolean;
	module: string;
	value: string;
	version?: string;
	title?: string;
	noedit?: boolean;
}

// Interface for component props
interface ActionTableProps {
	list?: ActionTableItem[];
	dispatch: (action: [string, ActionTableItem | string]) => void;
}

const ActionTableRewrite = ( item: ActionTableItem ): string => {

	if( item.type === "regions" && item.child )
		return "country";

	return item.type || "";
};

export const ActionTable = ( props: ActionTableProps ) => {
	return(
		<div className={"action-table-wrap"}>
			<table className={"action-table"}>
				<thead className={"action-thead"}>
					<tr>
						<th className={"action-thead-title"}>Inclusions</th>
						<th className={"action-thead-title"}>Filters</th>
						<th className={"action-thead-title"}>Restrictions</th>
						<th className={"action-thead-title"}>Actions</th>
					</tr>
				</thead>

				<tbody className={"action-tbody"}>
				{
					(props.list || []).map(( item: ActionTableItem ) => {
						return (
							<tr key={ item.module + ":" + item.value + ":" + item.version }>
								<td className={"action-tbody-cell"}>{
									ActionTableRewrite( item )
								}</td>
								<td className={"action-tbody-cell"}>{ item.title || item.value || "" }</td>
								<td className={"action-tbody-cell"}>{ item.version || "" }</td>
								<td className={"action-tbody-cell"}>
									<div className={"action-edit"}>
										{
											true != item.noedit &&
											<div className={"action-tbody-edit"} onClick={() => props.dispatch([ "edit", item ])}>edit</div>
										}
										<div className={"action-tbody-remove"} onClick={() => props.dispatch([ "remove", item.value ])}>X</div>
									</div>
								</td>
							</tr>
						);
					})
				}
				</tbody>
			</table>
		</div>
	);
};